import React from 'react';
import PropTypes from 'prop-types';
import { Text, Icon, Tooltip } from '@reservamos/elements';
import FixedTooltip from './FixedTooltip';

/**
 * CustomTooltip component.
 * Renders either a FixedTooltip or the standard Tooltip from elements.
 * @param {object} props - content, width, useFixed.
 * @param {string|string[]} props.content - Tooltip text content. Accepts a string or array of strings.
 * @param {number} props.width - Tooltip width in pixels.
 * @param {boolean} props.useFixed - Use position fixed tooltip to escape overflow containers.
 * @returns {JSX.Element|null} The rendered tooltip component.
 */
const CustomTooltip = ({ content, width, useFixed }) => {
  if (!content) return null;

  if (useFixed) {
    return <FixedTooltip content={content} width={width} />;
  }

  const tooltipContent = [].concat(content).map((line) => (
    <Text key={line} size="XS" color="grayMedium">
      {line}
    </Text>
  ));

  return (
    <Tooltip type="top" variant="light" widthBox={width} customContent={tooltipContent}>
      <Icon size="S" type="badgeQuestion" />
    </Tooltip>
  );
};

CustomTooltip.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  width: PropTypes.number,
  useFixed: PropTypes.bool,
};

CustomTooltip.defaultProps = {
  content: '',
  width: 220,
  useFixed: false,
};

export default CustomTooltip;
